import humanize from 'underscore.string/humanize';

angular.module('gym.contacts').controller('AddBluefinPaymentDetailsCtrl', ["$scope", "$modalInstance", "$timeout", "gym", "BluefinStoreService", "contact", "CreditCardValidationService", "PaymentDetailsSharingService", "paymentAccount", "defaultPaymentMethod", function($scope, $modalInstance, $timeout, gym, BluefinStoreService, contact, CreditCardValidationService, PaymentDetailsSharingService, paymentAccount, defaultPaymentMethod) {
  var card, ref, showError;
  $scope.isShared = (defaultPaymentMethod != null ? (ref = defaultPaymentMethod.all_contacts) != null ? ref.length : void 0 : void 0) > 1;
  $scope.card = card = {};
  showError = function(message = 'There was an error processing the request.') {
    $timeout(function() {
      return $scope.card.error_message = humanize(message);
    });
    return $scope.submitting = false;
  };
  $scope.checkCardNumber = function() {
    var ref1;
    card.card_number = (ref1 = card.card_number) != null ? ref1.replace(/[^0-9]/g, '') : void 0;
    return $scope.creditCardValid = CreditCardValidationService.check(card.card_number);
  };
  $scope.sharePaymentDetails = function() {
    $modalInstance.dismiss();
    return PaymentDetailsSharingService.share(contact);
  };
  $scope.checkName = function(name) {
    return $scope.nameValid = CreditCardValidationService.nameValid(name);
  };
  $scope.isReady = function() {
    return $scope.nameValid && $scope.creditCardValid && !$scope.submitting;
  };
  $scope.submit = function(type) {
    delete $scope.card.error_message;
    $scope.submitting = true;
    return BluefinStoreService.store(paymentAccount, angular.copy($scope.card), type).then(function(card) {
      if (card.error_message) {
        return showError(card.error_message);
      } else {
        card.rootObjectName = 'payment_method';
        card.default = !$scope.isShared;
        return contact.doPOST(card, 'bluefin').then(function(data) {
          return $modalInstance.close(data);
        }, function() {
          return showError();
        });
      }
    }, function(data) {
      return showError();
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
